import {Material} from '../types'

export const getMaterialsByAppIds = (materials: Material[], appIds: string[]) => {
  if (appIds.length === 0 || materials.length === 0) return []

  return materials.filter(material => {
    const materialAppIds = material.apps.map(app => app.id)
    return materialAppIds.some(materialAppId => appIds.includes(materialAppId))
  })
}
